import { OmnibarActionType, OmnibarEntry } from '../omnibar-interfaces';

// \b treats "é" as a non-word character, so the verbs are terminated by whitespace instead.
const createVerbs = /^(Opret|Dan|Ny|Nyt|Registrér|Indkald|Udsted|Opstart|Gennemfør)(?=\s|$)/i;
const editVerbs = /^(Redigér|Skift)(?=\s|$)/i;

export function entryActionType(entry: OmnibarEntry): OmnibarActionType {
  if (entry.actionType) return entry.actionType;
  if (createVerbs.test(entry.label)) return 'Opret';
  if (editVerbs.test(entry.label)) return 'Redigér';
  return 'Åbn';
}
